import { ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';
import BadgeAudible from '@customer/components/data-display/badge-audible/BadgeAudible';
import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { useTranslation } from 'react-i18next';
import styles from './InvestigationHeaderSummary.module.scss';
import GeofenceInteractionTypeRenderer from '@customer/components/tables/cells/geofence-interaction-type/GeofenceInteractionTypeRenderer';
import VehicleInteractionTypeRenderer from '@customer/components/tables/cells/vehicle-interaction-type/VehicleInteractionTypeRenderer';
import { AssetInvestigationType, InvestigationModel } from '@customer/store/apis/investigationsApi';
import { parseInvestigationType } from '@customer/shared/utils/investigationHelper';

interface InvestigationHeaderSummaryProps {
  interactionType: AssetInvestigationType;
  investigation?: InvestigationModel;
}

export const InvestigationHeaderSummary = ({
  interactionType,
  investigation,
}: InvestigationHeaderSummaryProps): ReactElement => {
  const { t } = useTranslation();
  const { showTimeAndDateFromIso } = useLocaleFormatter();

  const { vi, gi, custom } = parseInvestigationType(interactionType);

  return (
    <div className={styles.headerSummary}>
      <div className={styles.headerSummary__titleRow}>
        {investigation?.name ? (
          <div>{investigation.name}</div>
        ) : (
          <Skeleton width="200px" height="36px" />
        )}

        {custom !== true && (
          <>
            {investigation ? (
              typeof investigation.aud === 'boolean' ? (
                <BadgeAudible isAudible={investigation.aud} />
              ) : null
            ) : (
              <Skeleton width="130px" height="32px" />
            )}

            {investigation ? (
              vi ? (
                <VehicleInteractionTypeRenderer value={vi} size="small" />
              ) : gi ? (
                <GeofenceInteractionTypeRenderer value={gi} size="small" />
              ) : null
            ) : (
              <Skeleton width="200px" height="36px" />
            )}
          </>
        )}
      </div>

      <div className={styles.headerSummary__subtitleRow}>
        {investigation ? (
          <div className={styles.subtitle}>
            {vi
              ? t('VehicleInteraction')
              : gi
                ? t('GeofenceInteraction')
                : custom
                  ? t('CustomInvestigation')
                  : ''}
          </div>
        ) : (
          <Skeleton width="140px" height="24px" />
        )}
        {investigation ? (
          investigation.it === AssetInvestigationType.Custom ? (
            <div className={styles.timestamp}>
              {`${showTimeAndDateFromIso(investigation.tsStart)} -
                ${showTimeAndDateFromIso(investigation.tsEnd)}`}
            </div>
          ) : (
            <div className={styles.timestamp}>{showTimeAndDateFromIso(investigation.ts)}</div>
          )
        ) : (
          <Skeleton width="150px" />
        )}
      </div>
    </div>
  );
};

export default InvestigationHeaderSummary;
